// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"240":"workshop-edit-job","482":"group-job","494":"workshop-edit-jon","984":"workshop"}[chunkId] || chunkId) + "-legacy." + {"216":"68ce7661","240":"02a476c5","249":"c04c008b","482":"d5563a4e","494":"d1bda0b2","824":"951d8756","875":"e4cb34d6","984":"01fde1ca"}[chunkId] + ".js";
};